module.exports = __webpack_public_path__ + "img/payments.24eb3c82.svg";